/*
 * ATTENTION: An "eval-source-map" devtool has been used.
 * This devtool is neither made for production nor for readable output files.
 * It uses "eval()" calls to create a separate source file with attached SourceMaps in the browser devtools.
 * If you are trying to read the output file, select a different devtool (https://webpack.js.org/configuration/devtool/)
 * or disable the default devtool with "devtool: false".
 * If you are looking for production-ready output files, see mode: "production" (https://webpack.js.org/configuration/mode/).
 */
/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./zrc/scripts/sections/homepage/featured-collection.js":
/*!**************************************************************!*\
  !*** ./zrc/scripts/sections/homepage/featured-collection.js ***!
  \**************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var hequalizer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! hequalizer */ \"./node_modules/hequalizer/hequalizer.min.js\");\n/* harmony import */ var hequalizer__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(hequalizer__WEBPACK_IMPORTED_MODULE_0__);\n/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! swiper */ \"./node_modules/swiper/swiper.esm.js\");\n/* eslint-disable @babel/object-curly-spacing */\n\n\nconst nameCustomElement = \"featured-collection\";\nclass FeaturedCollection extends window.HTMLElement {\n  connectedCallback() {\n    this.configSwipper();\n    this.configHequalizer();\n  }\n  configSwipper() {\n    const $sliderContainer = this.querySelector(\".featured-collection-items\");\n    const $prevButton = this.querySelector(`.featured-collection-arrow.prev`);\n    const $nextButton = this.querySelector(`.featured-collection-arrow.next`);\n    new swiper__WEBPACK_IMPORTED_MODULE_1__.default($sliderContainer, {\n      modules: [swiper__WEBPACK_IMPORTED_MODULE_1__.Navigation, swiper__WEBPACK_IMPORTED_MODULE_1__.FreeMode],\n      loop: false,\n      slidesPerView: \"auto\",\n      centerInsufficientSlides: true,\n      navigation: {\n        prevEl: $prevButton,\n        nextEl: $nextButton\n      },\n      freeMode: {\n        enabled: true,\n        momentumBounce: false\n      },\n      breakpoints: {\n        1: {\n          allowTouchMove: true\n        },\n        835: {\n          allowTouchMove: false\n        }\n      }\n    });\n  }\n  configHequalizer() {\n    const $images = this.querySelectorAll(\".product-card__swiper\");\n    new (hequalizer__WEBPACK_IMPORTED_MODULE_0___default())($images, {\n      on: {\n        init: row => {\n          this.style.setProperty(\"--height-images\", `${row}px`);\n        },\n        afterResize: row => {\n          this.style.setProperty(\"--height-images\", `${row}px`);\n        }\n      }\n    });\n  }\n}\nif (!window.customElements.get(nameCustomElement)) {\n  window.customElements.define(nameCustomElement, FeaturedCollection);\n}//# sourceURL=[module]\n//# sourceMappingURL=data:application/json;charset=utf-8;base64,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\n//# sourceURL=webpack-internal:///./zrc/scripts/sections/homepage/featured-collection.js\n");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		if(__webpack_module_cache__[moduleId]) {
/******/ 			return __webpack_module_cache__[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/******/ 	// the startup function
/******/ 	// It's empty as some runtime module handles the default behavior
/******/ 	__webpack_require__.x = x => {};
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// Promise = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"featured-collection": 0
/******/ 		};
/******/ 		
/******/ 		var deferredModules = [
/******/ 			["./zrc/scripts/sections/homepage/featured-collection.js","commons"]
/******/ 		];
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		var checkDeferredModules = x => {};
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime, executeModules] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0, resolves = [];
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					resolves.push(installedChunks[chunkId][0]);
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			for(moduleId in moreModules) {
/******/ 				if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 					__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 				}
/******/ 			}
/******/ 			if(runtime) runtime(__webpack_require__);
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			while(resolves.length) {
/******/ 				resolves.shift()();
/******/ 			}
/******/ 		
/******/ 			// add entry modules from loaded chunk to deferred list
/******/ 			if(executeModules) deferredModules.push.apply(deferredModules, executeModules);
/******/ 		
/******/ 			// run deferred modules when all chunks ready
/******/ 			return checkDeferredModules();
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = globalThis["webpackChunkgetmore_workflow"] = globalThis["webpackChunkgetmore_workflow"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 		
/******/ 		function checkDeferredModulesImpl() {
/******/ 			var result;
/******/ 			for(var i = 0; i < deferredModules.length; i++) {
/******/ 				var deferredModule = deferredModules[i];
/******/ 				var fulfilled = true;
/******/ 				for(var j = 1; j < deferredModule.length; j++) {
/******/ 					var depId = deferredModule[j];
/******/ 					if(installedChunks[depId] !== 0) fulfilled = false;
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferredModules.splice(i--, 1);
/******/ 					result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
/******/ 				}
/******/ 			}
/******/ 			if(deferredModules.length === 0) {
/******/ 				__webpack_require__.x();
/******/ 				__webpack_require__.x = x => {};
/******/ 			}
/******/ 			return result;
/******/ 		}
/******/ 		var startup = __webpack_require__.x;
/******/ 		__webpack_require__.x = () => {
/******/ 			// reset startup function so it can be called again when more startup code is added
/******/ 			__webpack_require__.x = startup || (x => {});
/******/ 			return (checkDeferredModules = checkDeferredModulesImpl)();
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	// run startup
/******/ 	__webpack_require__.x();
/******/ })()
;